// import { constants } from "../../../../../../core";

const getAttributeValues = (product) => {
    const { hasAttributes, fields = [] } = product;

    if (hasAttributes) {
        return Object.keys(fields).reduce((values, field) => {
            return {
                ...values,
                [`Attribute_${field}`]: "",
            };
        }, {});
    }
};

const getFieldDataId = (product) => {
    const { hasAttributes } = product;

    if (hasAttributes) {
        return {
            Field_Data_Id: "",
        };
    }
};

export const getInitialValues = (
    settings,
    product = {},
    savedStoreCartValues = {},
) => {
 
    const values = {
        Product_Id: product.id,
        Product_Quantity: 1,
        ...getAttributeValues(product),
        ...getFieldDataId(product),
    };
    // Override any existing data with user-input data that has been stored
    if (Object.keys(savedStoreCartValues).length > 0) {
        return {
            ...values,
            ...savedStoreCartValues,
        };
    }
   
    return values;
};
